import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import {ButtonStyle} from 'ui-library/buttons/Button';
import {GRAY_LIGHT} from 'ui-library/Colors';
import Modal from 'ui-library/modals/Modal';
import {capitalize} from 'util/NameUtil';
import {dispatchBulkDeleteWorklists, RefreshOptions} from 'worklists/WorklistActions';
import {WorklistSummary, worklistTypeDisplayName} from 'worklists/WorklistConstants';

export interface DeleteWorklistsModalProps {
  worklists: Array<WorklistSummary>;
  refreshOptions: RefreshOptions;
  onRequestClose: () => void;
  onRequestSubmit: () => void;
}

const COLUMN_WIDTHS = {
  NAME: 6,
  TYPE: 6,
};

export default function DeleteWorklistsModal(props: DeleteWorklistsModalProps): JSX.Element {
  function deleteWorklists(): void {
    dispatchBulkDeleteWorklists(
      props.worklists.map((w) => w.id),
      props.refreshOptions
    );
  }

  return (
    <Modal
      buttons={[
        {
          submit: true,
          text: 'Delete worklists',
          style: ButtonStyle.NEGATIVE,
        },
      ]}
      onRequestClose={props.onRequestClose}
      onRequestSubmit={() => {
        deleteWorklists();
        props.onRequestSubmit();
      }}
      title="Delete worklists"
      titleIcon={ModelTypeConstants.WORKLIST}
    >
      <>
        <Row key="title">
          <Col sm={COLUMN_WIDTHS.NAME}>
            <h5>Name</h5>
          </Col>
          <Col sm={COLUMN_WIDTHS.TYPE}>
            <h5>Type</h5>
          </Col>
        </Row>
        {props.worklists.map((w) => (
          <Row className={css(styles.tableRow)} key={w.id}>
            <Col sm={COLUMN_WIDTHS.NAME}>{w.name}</Col>
            <Col sm={COLUMN_WIDTHS.TYPE}>{capitalize(worklistTypeDisplayName(w.itemType))}</Col>
          </Row>
        ))}
      </>
    </Modal>
  );
}

const styles = StyleSheet.create({
  tableRow: {
    marginBottom: 0,
    padding: '5px 0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderTop: `1px solid ${GRAY_LIGHT}`,
  },
});
